
export const search = {
  inputs: [
    {
      type: 'InputText',
      title: 'Number',
      span: 6,
      placeholder: 'Number Keyword',
      getter: 'state/search/no',
      setter: 'commit/search/setNo',
      width: 200
    },
    {
      type: 'InputDateRangePicker',
      title: 'Date',
      span: 6,
      getter: 'state/search/dateRange',
      setter: 'commit/search/setDateRange'
    },
    {
      type: 'InputSelect',
      title: 'OUT Warehouse',
      span: 6,
      options: 'getters/warehosuesAll',
      getter: 'state/search/warehouse',
      setter: 'commit/search/setWarehouse',
      defaultValue: 0
    },
    {
      type: 'InputSelect',
      title: 'IN Warehouse',
      span: 6,
      options: 'getters/warehosuesAll',
      getter: 'state/search/inWarehouse',
      setter: 'commit/search/setInWarehouse',
      defaultValue: 0
    },

    {
      type: 'InputSelect',
      title: 'Status',
      span: 6,
      options: 'getters/search/orderStatus',
      getter: 'state/search/status',
      setter: 'commit/search/setStatus',
      defaultValue: 0
    },
    {
      type: 'InputText',
      title: 'Product Inside',
      span: 6,
      placeholder: 'Enter Products Keyword',
      getter: 'state/search/product',
      setter: 'commit/search/setProduct',
      width: 200
    }
  ],
  lines: [
    {
      prop: 'no',
      label: 'Number',
      className: 'table-column-sheet-number-style',
      width: 115
    },
    {
      prop: 'ColumnShow',
      label: 'OUT Warehouse',
      getter: 'warehouseId',
      trans: 'getters/getWarehouseName',
      width: 120
    },
    {
      prop: 'ColumnShow',
      label: 'In Warehouse',
      getter: 'inWarehouseId',
      trans: 'getters/getWarehouseName',
      width: 120
    },
    {
      prop: 'qty',
      label: 'QTY.',
      width: 70,
      className: 'table-column-list-type-color-bold'
    },
    // {
    //   prop: 'date',
    //   label: 'Date',
    //   width: 110
    // },
    {
      prop: 'ColumnShow',
      label: 'Date',
      getter: 'date',
      trans: 'getters/dateFormatAu',
      align: 'center',
      width: 110
    },
    {
      prop: 'lastApproverAndDate',
      label: 'Last Approver&Date',
      width: 200
    },
    {
      prop: 'status',
      label: 'Status',
      width: 85
    },
    {
      prop: 'ColumnViewBtn',
      label: 'Action'
    }

  ]
}

const edit = {
  inputs: [
    {
      type: 'InputSelect',
      title: 'OUT Whs.',
      span: 6,
      options: 'state/warehouses',
      getter: 'state/edit/warehouseId',
      setter: 'commit/edit/setWarehouse',
      defaultValue: ''
    },
    {
      type: 'InputSelect',
      title: 'IN Warehouse',
      span: 6,
      options: 'state/warehouses',
      getter: 'state/edit/inWarehouseId',
      setter: 'commit/edit/setInWarehouse',
      defaultValue: ''
    },
    {
      type: 'InputDatePicker',
      title: 'Date',
      span: 6,
      getter: 'state/edit/date',
      setter: 'commit/edit/setDate',
      width: 200
    },
    {
      type: 'InputText',
      title: 'Comments',
      span: 12,
      placeholder: 'Enter comments of this sheet',
      getter: 'state/edit/comments',
      setter: 'commit/edit/setComments',
      width: 615
    }
  ],
  lines: [
    {
      prop: 'ColumnProductCodeSelectPopper',
      label: 'Item Code',
      width: 190
    },
    {
      prop: 'ColumnProductNameInput',
      label: 'Item Name',
      width: 330
    },
    {
      prop: 'product.unit',
      label: 'Unit',
      width: 70
    },
    {
      prop: 'ColumnInputQty',
      label: 'Qty',
      width: 85
    },
    {
      prop: 'ColumnInputDesc',
      label: 'Line Description'
    }
  ]

}

const draft = {
  inputs: [
    {
      type: 'InputShow',
      title: 'OUT Warehouse',
      span: 6,
      getter: 'state/edit/warehouseId',
      trans: 'getters/getWarehouseName',
      labelClass: 'detail-text-grey'
    },
    {
      type: 'InputShow',
      title: 'Number',
      span: 6,
      getter: 'state/edit/no',
      labelClass: 'detail-text-strong'
    },
    {
      type: 'InputShow',
      title: 'Date',
      span: 12,
      getter: 'state/edit/date',
      labelClass: 'detail-text-strong'
    },
    {
      type: 'InputShow',
      title: 'IN Warehouse',
      span: 6,
      getter: 'state/edit/inWarehouseId',
      trans: 'getters/getWarehouseName',
      labelClass: 'detail-text-grey'
    },
    {
      type: 'InputShow',
      title: 'Comments',
      span: 12,
      getter: 'state/edit/comments',
      labelClass: 'detail-text-grey'
    }
  ],
  lines: [
    {
      prop: 'product.code',
      label: 'Item Code',
      width: 150
    },
    {
      prop: 'product.name',
      label: 'Item Name',
      width: 350
    },
    {
      prop: 'product.unit',
      label: 'Unit',
      width: 70
    },
    {
      prop: 'quantity',
      label: 'Qty',
      className: 'table-column-sheet-number-style',
      width: 85
    },
    {
      prop: 'desc',
      label: 'Line Description'
    }
  ]
}

export default { search, edit, draft, approve: draft }
